/**
 * @description Renders the tab content when its visible
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Box from '@mui/material/Box';

import ErrorBoundary from './ErrorBoundary';

/**
 * @prop {ReactComponent} Content - react component to be rendered when the tab content is visible
 * @prop {number} id - id of the tab
 * @prop {boolean} visible - visiblity of the tab if its currently selected or not
 */
const TabContent = ({ Content, id, visible }) => {
  // If the tab is not visible, render nothing
  if (!visible) {
    return null;
  }

  return (
    <Box
      aria-labelledby={`tab-${ id }`}
      role='tabpanel'
      id={`tabpanel-${ id }`}
      width='100%'
      height='100%'
    >
      <ErrorBoundary>
        <Content />
      </ErrorBoundary>
    </Box>
  );
};

TabContent.propTypes = {
  Content: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired
};

export default TabContent;
